var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCloudTopRight(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 257,
    height: 98,
    viewBox: "0 0 257 98",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.0349 55.4706C26.1015 52.2701 35.0405 52.2097 41.0804 57.1011C45.3687 37.7771 66.2666 23.7068 85.7753 27.0281C88.6744 27.5112 91.8153 28.3566 94.4728 27.0885C96.5867 26.1223 97.9155 24.0691 99.3047 22.1971C111.868 5.04702 135.121 -3.52802 155.777 1.36338C176.434 6.25477 193.345 24.371 196.848 45.3255C208.505 37.7167 224.33 37.1128 236.53 43.8762C248.731 50.5792 256.643 64.3476 256.401 78.2367C256.341 80.7126 256.039 83.2489 254.952 85.4833C251.509 92.4882 242.087 93.5752 234.295 93.7563C180.601 94.9037 126.907 95.5076 73.2125 95.9907C56.4821 96.1115 37.6981 99.4932 21.3301 95.3264C-5.9701 88.3819 -7.41969 67.3066 19.0349 55.4706Z",
    fill: "#3E809D",
    fillOpacity: 0.5
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloudTopRight);
export default __webpack_public_path__ + "static/media/cloud-top-right.372836f0c1c688213ce090d2b4f9eba1.svg";
export { ForwardRef as ReactComponent };